export const REQUEST_GET_PRODUCER_POLICIES = 'REQUEST_GET_PRODUCER_POLICIES';
export const SUCCESS_GET_PRODUCER_POLICIES = 'SUCCESS_GET_PRODUCER_POLICIES';
export const REQUEST_GET_PRODUCER_EXPANDED = 'REQUEST_GET_PRODUCER_EXPANDED';
export const SUCCESS_GET_PRODUCER_EXPANDED = 'SUCCESS_GET_PRODUCER_EXPANDED';
export const REQUEST_GET_PRODUCER = 'REQUEST_GET_PRODUCER';
export const SUCCESS_GET_PRODUCER = 'SUCCESS_GET_PRODUCER';
export const FAILURE_GET_PRODUCER = 'FAILURE_GET_PRODUCER';
export const SUCCESS_GET_FILTERS = 'SUCCESS_GET_FILTERS';
export const SUCCESS_GET_LEVELS = 'SUCCESS_GET_LEVELS';
